import React, { useEffect, useState } from 'react';
import {
    faBuilding, faPlus, faToggleOn, faToggleOff, faCheck, faTimes, faPen,
} from '@fortawesome/free-solid-svg-icons';
import Tab from 'components/UI/Tab';
import Flight from 'components/BusinessLogic/Components/Flights';
import Hotel from 'components/BusinessLogic/Components/Hotel';
import Service from 'components/BusinessLogic/Components/Service';
import Insurance from 'components/BusinessLogic/Components/Insurance';
import Button from 'components/UI/Button';
import Skeleton from 'components/UI/Skeleton';
import { connect } from 'react-redux';
import _ from 'lodash';
import Col from 'components/UI/Layout/Col';
import PropTypes from 'prop-types';
import { humanReadableShortDate } from 'utils/formatters';
import { loadRequest, requestDetailsIncludes } from 'store/dispatchers/requests.dispatchers';
import { buildMetaRequestSelector, buildRequestSelector } from 'store/selectors/requests.selector';
import { containsIncludes } from 'store/dispatchers/helpers';
import { brandValues } from 'utils/brandValues';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons/faTrashAlt';
import {
    deleteRequestQuote,
    updateRequestQuote,
    deleteRequestQuoteBundle,
} from 'store/dispatchers/requestQuotes.dispatchers';
import { attachServices } from 'store/dispatchers/requestHotels.dispatchers';
import Dialog from 'components/UI/Dialog';
import LoadingSpinner from 'components/UI/LoadingIndicators/LoadingSpinner';
import Table from 'components/UI/Table';
import RequestQuoteBundle from 'components/BusinessLogic/RequestQuoteBundle';
import moment from 'moment/moment';
import { CONSTANTS } from 'services/constants';
import AttachServiceModal from 'components/BusinessLogic/AttachServiceModal';
import InformativeService from 'components/BusinessLogic/InformativeService/Loadable';
import Title from 'components/UI/Title';
import InformativeHotel from 'components/BusinessLogic/InformativeHotel/Loadable';
import InformativeFlight from 'components/BusinessLogic/InformativeFlight/Loadable';
import Dropdown from 'components/UI/Dropdown';

function RequestSummary({
    requestId,
    getRequest,
    request,
    metaRequest,
    isB2cPage,
    removeRequestQuote,
    upgradeRequestQuote,
    removeRequestQuoteBundle,
    saveAttachServices,
})
{
    const [editQuoteBundle, setEditQuoteBundle] = useState(null);
    const bundleHeaders = ['Name', 'Edit', 'Delete'];
    const defaultMails = _.get(brandValues, `${isB2cPage ? 'B2C' : 'B2B'}.EMAILS`);
    const defaultActiveTab = _.get(request, 'requestQuotes[0].id');
    const [showBundleModal, setShowBundleModal] = useState(false);
    const [showDialogInformative, setShowDialogInformative] = useState(false);
    const [showDialogHotel, setShowDialogHotel] = useState(false);
    const [editableFlight, setEditableFlight] = useState(null);
    const [showDialogFlight, setShowDialogFlight] = useState(false);
    const [editableHotel, setEditableHotel] = useState(null);
    const [editableService, setEditableService] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);
    const [deletingQuoteBundle, setDeletingQuoteBundle] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showAttachServiceModal, setShowAttachServiceModal] = useState(false);
    const [activeTab, setActiveTab] = useState(defaultActiveTab ?? 0);
    const [isLoadingQuote, setIsLoadingQuote] = useState(false);
    const [suggestedMembers, setSuggestedMembers] = useState(0);
    const [hotelActiveComponents, setHotelActiveComponents] = useState([]);
    const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
    const [selectedOptionSubject, setSelectedOptionSubject] = useState('');
    const [activeQuote, setActiveQuote] = useState(request?.requestQuotes?.[defaultActiveTab] ?? null);
    const [orderedComponents, setOrderedComponents] = useState([]);

    let conciergeEmail = request.user?.userEmails?.find((email) => email.default)?.email;

    const handleEditService = (requestComponentId, type) =>
    {
        if (type === 'Hotel')
        {
            setEditableHotel(requestComponentId);
            setShowDialogHotel(true);
            return;
        }

        if (type === 'Flight')
        {
            setEditableFlight(requestComponentId);
            setShowDialogFlight(true);
            return;
        }

        setEditableService(requestComponentId);
        setShowDialogInformative(true);
    };

    const handleDeleteOption = () =>
    {
        if (!activeTab)
        {
            return;
        }
        removeRequestQuote(activeTab).finally(() =>
        {
            setShowConfirmDeleteModal(false);
        });
    };

    const handleConfirmDeleteQuoteBundle = (requestQuoteId, requestQuoteBundleId) =>
    {
        setIsDeleting(true);
        setDeletingQuoteBundle({ requestQuoteId, requestQuoteBundleId });
    };

    const handleDeleteQuoteBundle = () =>
    {
        setIsLoading(true);
        removeRequestQuoteBundle(deletingQuoteBundle.requestQuoteId, deletingQuoteBundle.requestQuoteBundleId).finally(() =>
        {
            setIsLoading(false);
            setIsDeleting(false);
        });
    };

    const handlePDFVisibility = () =>
    {
        if (!activeTab)
        {
            return;
        }

        const currentQuote = request.requestQuotes.find((requestQuote) => requestQuote.id === activeTab);
        setIsLoadingQuote(true);
        upgradeRequestQuote(activeTab, {
            include_on_pdf: parseInt(currentQuote.include_on_pdf, 10) === 1 ? 0 : 1,
        }).finally(() =>
        {
            setIsLoadingQuote(false);
        });
    };

    if (!conciergeEmail)
    {
        conciergeEmail = _.get(request.user?.userEmails, '[0].email');
    }

    if (!conciergeEmail)
    {
        conciergeEmail = _.get(request.user?.conciergeGroups, '[0].concierges[0].emails[0].email', null);
    }

    const loadData = async () =>
    {
        if (_.isEmpty(request) || !containsIncludes(requestDetailsIncludes, metaRequest.loadedIncludes))
        {
            getRequest(requestId);
        }
    };

    const getOrderedComponents = (requestQuoteComponents) => requestQuoteComponents?.sort((a, b) =>
    {
        let componentDateA = getComponentDate(a);
        let componentDateB = getComponentDate(b);

        componentDateA = componentDateA ? moment(componentDateA, CONSTANTS.FORMATS.DATE).format(CONSTANTS.FORMATS.QUERY_DATE) : '';
        componentDateB = componentDateB ? moment(componentDateB, CONSTANTS.FORMATS.DATE).format(CONSTANTS.FORMATS.QUERY_DATE) : '';

        if (componentDateA < componentDateB)
        {
            return -1;
        }
        if (componentDateA > componentDateB)
        {
            return 1;
        }
        return 0;
    });

    useEffect(() =>
    {
        loadData();
    }, []);

    useEffect(() =>
    {
        if (request.requestHotels)
        {
            const tabQuote = request?.requestQuotes?.find((requestQuote) => requestQuote.id === activeTab) ?? null;
            setActiveQuote(tabQuote);
            setSelectedOptionSubject(` - Option Id ${activeTab + 1}${activeQuote?.name ? `: ${activeQuote?.name}` : ''}`);
            setOrderedComponents(getOrderedComponents(tabQuote?.requestQuoteComponents));

            const hotelComponents = tabQuote?.requestQuoteComponents?.filter((requestQuoteComponent) => requestQuoteComponent.component_type === 'Hotel') ?? [];
            setHotelActiveComponents(hotelComponents);
            setSuggestedMembers(hotelComponents.reduce((hotelSuggested, hotelComponent) => Math.max(hotelSuggested, _.first(hotelComponent.requestComponent.requestHotelRooms)?.number_of_adults ?? 1), 1));
        }
    }, [activeTab, request]);

    const handleSaveServices = async (hotelId, vendorServiceIds) =>
    {
        if (!hotelId)
        {
            return;
        }

        setIsLoading(true);
        const filtered = _.keys(vendorServiceIds).filter((vendorServiceId) => vendorServiceIds[vendorServiceId]);
        const component = hotelActiveComponents?.find((hotelComponent) => hotelComponent.requestComponent.hotel.id === hotelId, []);

        saveAttachServices(activeTab, component.requestComponent.id, filtered).finally(() =>
        {
            setIsLoading(false);
            setShowAttachServiceModal(false);
        });
    };

    const canAddItems = () =>
    {
        const limit = moment().subtract(21, 'days');
        const hotels = hotelActiveComponents?.reduce((allHotels, hotelComponent) => allHotels.concat(hotelComponent.requestComponent.hotel.id), []);
        const hotelMinCheckin = hotelActiveComponents.reduce((min, hotelComponent) =>
        {
            const minCheckin = hotelComponent.requestComponent.requestHotelRooms.reduce((minRoom, hotelRoomComponent) =>
            {
                const roomDate = moment(hotelRoomComponent.checkin, CONSTANTS.FORMATS.DATE);
                return !minRoom ? roomDate : moment.min(roomDate, minRoom);
            }, null);

            return !min ? minCheckin : moment.min(minCheckin, min);
        }, null);

        return hotels.length > 0 && hotelMinCheckin && hotelMinCheckin.isAfter(limit);
    };

    const handleAddService = () =>
    {
        if (canAddItems())
        {
            setShowAttachServiceModal(true);
            return;
        }

        sendEmail();
    };

    const sendEmail = () =>
    {
        window.open(
            `mailto:${conciergeEmail ?? defaultMails.SERVICE}?subject=${encodeURIComponent(`Add Service to quote #${requestId}${selectedOptionSubject}`)}`,
            '_blank',
        );
    };

    const handleEditBundle = (quoteBundle) =>
    {
        setEditQuoteBundle(quoteBundle);
        setShowBundleModal(true);
    };

    useEffect(() =>
    {
        if (!showBundleModal)
        {
            setEditQuoteBundle(null);
        }
    }, [showBundleModal]);

    useEffect(() =>
    {
        if (!isDeleting)
        {
            setDeletingQuoteBundle(null);
        }
    }, [isDeleting]);

    const onChangeTab = ({ id }) =>
    {
        setActiveTab(parseInt(id, 10));
    };

    const handleAddInformativeService = () =>
    {
        if (canAddItems())
        {
            setEditableService(null);
            setShowDialogInformative(true);
        }
    };

    const handleAddInformativeFlight = () =>
    {
        if (canAddItems())
        {
            setEditableFlight(null);
            setShowDialogFlight(true);
        }
    };

    const handleAddInformativeHotel = () =>
    {
        if (canAddItems())
        {
            setEditableHotel(null);
            setShowDialogHotel(true);
        }
    };

    const getComponentDate = (component) =>
    {
        if (component.component_type === 'Flight')
        {
            return component.requestComponent.requestFlightLegs.length > 0
                ? component.requestComponent.requestFlightLegs[0].departure_date
                : null;
        }
        if (component.component_type === 'Hotel')
        {
            return component.requestComponent.requestHotelRooms.length > 0
                ? component.requestComponent.requestHotelRooms[0].checkin
                : null;
        }
        if (component.component_type === 'Service')
        {
            return component.requestComponent.service_date;
        }
        return null;
    };

    const getDateToShow = (component, previousComponent) =>
    {
        const aDate = getComponentDate(component);
        const pDate = previousComponent == null ? null : getComponentDate(previousComponent);

        return humanReadableShortDate((aDate !== pDate && pDate != null) || previousComponent === null ? aDate : null);
    };

    return (
        <div className="tw-mt-3">
            <Dialog
                model={{ value: showConfirmDeleteModal, setter: setShowConfirmDeleteModal }}
                footer={(
                    <>
                        <button
                            onClick={handleDeleteOption}
                            disabled={metaRequest.loading}
                            type="button"
                            className="tw-text-white tw-mt-3 tw-inline-flex tw-w-full tw-justify-center tw-rounded-md tw-border tw-bg-primary-default tw-px-4 tw-pt-2 tw-pb-1.5 tw-items-center tw-text-base tw-font-medium tw-shadow-sm hover:tw-bg-primary-hover focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500 focus:tw-ring-offset-2 sm:tw-mt-0 sm:tw-ml-3 sm:tw-w-auto sm:tw-text-sm"
                        >
                            Confirm <LoadingSpinner loading={metaRequest.loading ?? false} className="tw-mr-1 tw-ml-2" />
                        </button>
                        <button
                            onClick={() =>
                            {
                                setShowConfirmDeleteModal(false);
                            }}
                            type="button"
                            className="tw-mt-3 tw-inline-flex tw-w-full tw-justify-center tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-px-4 tw-pt-2 tw-pb-1.5 tw-items-center tw-text-base tw-font-medium tw-text-gray-700 tw-shadow-sm hover:tw-bg-gray-50 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500 focus:tw-ring-offset-2 sm:tw-mt-0 sm:tw-ml-3 sm:tw-w-auto sm:tw-text-sm"
                        >
                            Close
                        </button>
                    </>
                )}
            >
                <div>
                    <h3 className="tw-text-lg tw-font-medium tw-leading-6 tw-text-gray-900 dark:tw-text-gray-100">
                        Are you sure?
                    </h3>

                    <div className="tw-text-sm">
                        Do you really want to delete this record?
                    </div>
                </div>
            </Dialog>

            <div
                className="tw-mb-3 tw-grid tw-gap-3 tw-grid-cols-4 tw-max-w-[1050px] max-sm:tw-w-full max-sm:tw-justify-center"
            >
                <div className="tw-col max-lg:tw-col-span-2">
                    <Button
                        onClick={handleAddService}
                        margin="tw-mt-0"
                        icon={faPlus}
                        padding="tw-pb-2 tw-pt-3 tw-px-2"
                        type="primary"
                        iconMargin="tw-mx-2"
                        className="tw-w-full tw-border-neutral-200 dark:tw-text-neutral-700 tw-text-white max-sm:tw-flex max-sm:tw-items-center max-sm:tw-h-16"
                    >
                        Service
                    </Button>

                    <AttachServiceModal
                        showAttachServiceModal={showAttachServiceModal}
                        sendEmail={sendEmail}
                        setShowAttachServiceModal={setShowAttachServiceModal}
                        suggestedUsers={suggestedMembers}
                        hotelIds={hotelActiveComponents?.reduce((hotels, hotelComponent) => hotels.concat(hotelComponent.requestComponent.hotel.id), [])}
                        onSave={handleSaveServices}
                        loading={isLoading}
                    />
                </div>
                <div className="tw-col max-lg:tw-col-span-2">
                    <a
                        href={`mailto:${conciergeEmail ?? defaultMails.INSURANCE}?subject=${encodeURIComponent(`Add Insurance to quote #${requestId}${selectedOptionSubject}`)}`}
                        target="_blank"
                    >
                        <Button
                            margin="tw-mt-0"
                            padding="tw-pb-2 tw-pt-3 tw-px-2"
                            iconMargin="tw-mx-2"
                            className="tw-w-full tw-border-neutral-200 dark:tw-text-neutral-700 tw-text-white max-sm:tw-flex max-sm:tw-items-center max-sm:tw-h-16"
                            type="primary"
                            icon={faPlus}
                        >
                            Insurance
                        </Button>
                    </a>
                </div>
                <div className="tw-col max-lg:tw-col-span-2">
                    <a
                        href={`mailto:${defaultMails.AIR}?subject=${encodeURIComponent(`Add Flight to quote #${requestId}${selectedOptionSubject}`)}`}
                        target="_blank"
                    >
                        <Button
                            margin="tw-mt-0"
                            padding="tw-pb-2 tw-pt-3 tw-px-2"
                            type="primary"
                            icon={faPlus}
                            iconMargin="tw-mx-2"
                            className="tw-w-full tw-border-neutral-200 dark:tw-text-neutral-700 tw-text-white max-sm:tw-flex max-sm:tw-items-center max-sm:tw-h-16"
                        >
                            Flight
                        </Button>
                    </a>
                </div>
                <div className="tw-col max-lg:tw-col-span-2">
                    {activeQuote !== null && (
                        <Dropdown
                            label="Custom Item"
                            align="right"
                            icon={faPlus}
                            className="tw-w-full tw-border-neutral-200 dark:tw-text-neutral-700 tw-text-white max-sm:tw-flex max-sm:tw-items-center tw-pb-2 tw-pt-3 tw-px-2 max-sm:tw-h-16"
                        >
                            <div className="tw-col max-lg:tw-col-span-2">
                                <Button
                                    onClick={handleAddInformativeFlight}
                                    margin="tw-mt-0"
                                    padding="tw-pb-2 tw-pt-3 tw-px-2"
                                    type="custom"
                                    icon={faPlus}
                                    iconMargin="tw-mx-2"
                                    rounded="tw-border-0"
                                    iconClassName="tw-text-primary-default"
                                    className="tw-border-b-neutral-200 tw-border-b tw-w-full tw-text-left tw-border-l-4 hover:tw-border-l-primary-default hover:tw-border-b-primary-default tw-border-l-neutral-200 dark:tw-border-l-neutral-950 dark:tw-border-b-neutral-950 dark:hover:tw-border-l-primary-default dark:hover:tw-border-b-primary-default"
                                >
                                    Flight
                                </Button>
                            </div>
                            <div className="tw-col max-lg:tw-col-span-2">
                                <Button
                                    onClick={handleAddInformativeHotel}
                                    margin="tw-mt-0"
                                    padding="tw-pb-2 tw-pt-3 tw-px-2"
                                    type="custom"
                                    icon={faPlus}
                                    iconMargin="tw-mx-2"
                                    rounded="tw-border-0"
                                    iconClassName="tw-text-primary-default"
                                    className="tw-border-b-neutral-200 tw-border-b tw-w-full tw-text-left tw-border-l-4 hover:tw-border-l-primary-default hover:tw-border-b-primary-default tw-border-l-neutral-200 dark:tw-border-l-neutral-950 dark:tw-border-b-neutral-950 dark:hover:tw-border-l-primary-default dark:hover:tw-border-b-primary-default"
                                >
                                    Hotel
                                </Button>
                            </div>
                            <div className="tw-col max-lg:tw-col-span-2">
                                <Button
                                    onClick={handleAddInformativeService}
                                    margin="tw-mt-0"
                                    padding="tw-pb-2 tw-pt-3 tw-px-2"
                                    type="custom"
                                    icon={faPlus}
                                    iconMargin="tw-mx-2"
                                    iconClassName="tw-text-primary-default"
                                    className="tw-w-full tw-text-left tw-border-l-4 hover:tw-border-l-primary-default tw-border-l-neutral-200 dark:tw-border-l-neutral-950 dark:hover:tw-border-l-primary-default"
                                >
                                    Service
                                </Button>
                            </div>
                        </Dropdown>
                    )}
                </div>

            </div>
            {metaRequest.loading || !request.id ? (
                <Skeleton type="box" className="tw-w-full" height="tw-h-48" />
            ) : (
                <Tab
                    className="tw-w-full dark:tw-text-neutral-300 tw-overflow-auto tw-flex"
                    activeTab={activeTab}
                    tabs={request?.requestQuotes.map((requestQuote, index) => ({
                        id: requestQuote.id,
                        title: `Option ${index + 1}: ${requestQuote.name}`,
                    }))}
                    onChangeTab={onChangeTab}
                >
                    {activeQuote !== null
                        && (
                            <div className="tw-text-right">
                                <Button
                                    disabled={isLoadingQuote}
                                    loading={isLoadingQuote}
                                    margin="tw-mt-0"
                                    padding="tw-pb-2 tw-pt-3 tw-px-2"
                                    type="custom"
                                    icon={activeQuote?.include_on_pdf === 1 ? faToggleOn : faToggleOff}
                                    iconSize="2xl"
                                    iconMargin="tw-mx-2"
                                    customBg="tw-bg-transparent"
                                    onClick={handlePDFVisibility}
                                >
                                    PDF Visibility
                                </Button>

                                <Button
                                    margin="tw-mt-0 tw-ml-3"
                                    padding="tw-pb-2 tw-pt-3 tw-px-2"
                                    type="danger"
                                    icon={faTrashAlt}
                                    iconMargin="tw-mx-2"
                                    onClick={() =>
                                    {
                                        setShowConfirmDeleteModal(true);
                                    }}
                                >
                                    Delete this option
                                </Button>
                                <a
                                    href={`mailto:${conciergeEmail ?? defaultMails.BOOK_OPTION}?subject=${encodeURIComponent(`Book quote #${requestId}${selectedOptionSubject}`)}`}
                                    target="_blank"
                                >
                                    <Button
                                        margin="tw-mt-0 tw-ml-3"
                                        padding="tw-pb-2 tw-pt-3 tw-px-2"
                                        type="primary"
                                        icon={faBuilding}
                                        iconMargin="tw-mx-2"
                                    >
                                        Book this option
                                    </Button>
                                </a>
                            </div>
                        )}

                    {request?.requestQuotes.length === 0
                        && <p className="tw-py-3 tw-text-center">No quotes have been added yet</p>}

                    {request?.requestQuotes && (
                        <Col>
                            {request?.requestQuotes.map((q) => (
                                (activeTab === q.id) && (
                                    <Col key={q.id}>
                                        {orderedComponents.length === 0
                                            && <p className="tw-py-3 tw-text-center">No Items have been added yet</p>}
                                        {orderedComponents.map((c, index) => (
                                            <div
                                                className="tw-col-span-2 max-xl:tw-col-span-3 max-lg:tw-col-span-6 tw-mb-4"
                                                key={c.id}
                                            >
                                                {c.component_type === 'Flight' && (
                                                    <Flight
                                                        key={c.id}
                                                        requestQuoteId={q.id}
                                                        requestQuoteComponentId={c.id}
                                                        dateLabel={getDateToShow(c, index === 0 ? null : q.requestQuoteComponents[index - 1])}
                                                        flight={c.requestComponent}
                                                        showCommission={!isB2cPage}
                                                    ></Flight>
                                                )}

                                                {c.component_type === 'Hotel' && (
                                                    <Hotel
                                                        key={c.id}
                                                        requestQuoteId={q.id}
                                                        requestQuoteComponentId={c.id}
                                                        dateLabel={getDateToShow(c, index === 0 ? null : q.requestQuoteComponents[index - 1])}
                                                        hotel={c.requestComponent}
                                                        showCommission={!isB2cPage}
                                                    ></Hotel>
                                                )}

                                                {c.component_type === 'Service' && (
                                                    <Service
                                                        key={c.id}
                                                        requestQuoteId={q.id}
                                                        requestQuoteComponentId={c.id}
                                                        dateLabel={getDateToShow(c, index === 0 ? null : q.requestQuoteComponents[index - 1])}
                                                        service={c.requestComponent}
                                                        showCommission={!isB2cPage}
                                                        handleEditService={(type) => handleEditService(c.id, type)}
                                                    ></Service>
                                                )}

                                                {c.component_type === 'Insurance' && (
                                                    <Insurance
                                                        key={c.id}
                                                        requestQuoteId={q.id}
                                                        requestQuoteComponentId={c.id}
                                                        insurance={c.requestComponent}
                                                        showCommission={!isB2cPage}
                                                    ></Insurance>
                                                )}
                                            </div>
                                        ))}

                                        {q.requestQuoteBundles
                                            && (
                                                <>
                                                    <Col className="tw-mt-20 tw-ml-0">
                                                        <Title title="Packages" before margin="tw-m-0" padding="tw-p-0" />
                                                        <Button
                                                            margin="tw-mt-3 tw-ml-3 tw-mr-auto"
                                                            padding="tw-pb-1 tw-pt-1.5 tw-px-2"
                                                            icon={faPlus}
                                                            iconMargin="tw-mx-2"
                                                            onClick={() =>
                                                            {
                                                                setShowBundleModal(true);
                                                            }}
                                                        >
                                                            Package
                                                        </Button>

                                                        <RequestQuoteBundle
                                                            requestQuoteId={q.id}
                                                            editQuoteBundle={editQuoteBundle}
                                                            setShowBundleModal={setShowBundleModal}
                                                            showBundleModal={showBundleModal}
                                                            components={q.requestQuoteComponents}
                                                        />
                                                    </Col>

                                                    <Dialog
                                                        model={{ value: isDeleting, setter: setIsDeleting }}
                                                        footer={(
                                                            <>
                                                                <button
                                                                    onClick={handleDeleteQuoteBundle}
                                                                    disabled={isLoading}
                                                                    type="button"
                                                                    className="tw-bg-primary-default tw-mt-3 tw-inline-flex tw-w-full tw-justify-center tw-rounded-md tw-border tw-border-gray-300 tw-px-4 tw-pt-2 tw-pb-1.5 tw-items-center tw-text-base tw-font-medium tw-text-white tw-shadow-sm hover:tw-bg-primary-hover focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500 focus:tw-ring-offset-2 sm:tw-mt-0 sm:tw-ml-3 sm:tw-w-auto sm:tw-text-sm"
                                                                >
                                                                    Confirm <LoadingSpinner loading={isLoading} className="tw-ml-2" />
                                                                </button>
                                                                <button
                                                                    disabled={isLoading}
                                                                    onClick={() => setIsDeleting(false)}
                                                                    type="button"
                                                                    className="tw-mt-3 tw-inline-flex tw-w-full tw-justify-center tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-px-4 tw-pt-2 tw-pb-1.5 tw-items-center tw-text-base tw-font-medium tw-text-gray-700 tw-shadow-sm hover:tw-bg-gray-50 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500 focus:tw-ring-offset-2 sm:tw-mt-0 sm:tw-ml-3 sm:tw-w-auto sm:tw-text-sm"
                                                                >
                                                                    Close
                                                                </button>
                                                            </>
                                                        )}
                                                    >
                                                        <div>
                                                            <h3 className="tw-text-lg tw-font-medium tw-leading-6 tw-text-gray-900 dark:tw-text-gray-100">
                                                                Are you sure?
                                                            </h3>

                                                            <div className="tw-text-sm">
                                                                Do you really want to delete this record?
                                                            </div>
                                                        </div>
                                                    </Dialog>

                                                    <Table
                                                        data={q.requestQuoteBundles.map((requestQuoteBundle) => ({
                                                            id: requestQuoteBundle.id,
                                                            Name: requestQuoteBundle.name,
                                                            Edit: <Button
                                                                onClick={() => handleEditBundle(requestQuoteBundle)}
                                                                margin="tw-mt-0"
                                                                padding="tw-pb-2 tw-pt-3 tw-px-2"
                                                                type="custom"
                                                                customBg="tw-bg-transparent"
                                                                icon={faPen}
                                                                iconMargin="tw-mx-2"
                                                                className="tw-w-full tw-border-neutral-200 tw-text-primary-default max-sm:tw-flex max-sm:tw-items-center max-sm:tw-h-16"
                                                            >
                                                                Edit
                                                            </Button>,
                                                            Delete: <Button
                                                                margin="tw-mt-0"
                                                                padding="tw-pb-2 tw-pt-3 tw-px-2"
                                                                type="custom"
                                                                customBg="tw-bg-transparent"
                                                                icon={faTimes}
                                                                onClick={() =>
                                                                {
                                                                    handleConfirmDeleteQuoteBundle(q.id, requestQuoteBundle.id);
                                                                }}
                                                                iconMargin="tw-mx-2"
                                                                className="tw-w-full tw-border-neutral-200 tw-text-primary-default max-sm:tw-flex max-sm:tw-items-center max-sm:tw-h-16"
                                                            >
                                                                Delete
                                                            </Button>,
                                                        }))}
                                                        headers={bundleHeaders}
                                                        isLoading={metaRequest.loading}
                                                        containerClass="tw-px-0 tw-mb-3"
                                                    />
                                                </>
                                            )}
                                    </Col>
                                )
                            ))}
                        </Col>
                    )}
                </Tab>
            )}

            {activeTab !== null
                && (
                    <InformativeService
                        isAdding={showDialogInformative}
                        setIsAdding={setShowDialogInformative}
                        requestQuoteId={activeTab}
                        requestComponentId={editableService}
                    />
                )}

            {activeTab !== null
                && (
                    <InformativeHotel
                        isShowing={showDialogHotel}
                        setIsShowing={setShowDialogHotel}
                        requestQuoteId={activeTab}
                        requestComponentId={editableHotel}
                    />
                )}

            {activeTab !== null
                && <InformativeFlight isShowing={showDialogFlight} setIsShowing={setShowDialogFlight} requestQuoteId={activeTab} requestComponentId={editableFlight} />}

        </div>
    );
}

RequestSummary.defaultProps = {
    isB2cPage: false,
};

RequestSummary.propTypes = {
    isB2cPage: PropTypes.bool,
    requestId: PropTypes.number.isRequired,
    getRequest: PropTypes.func,
    upgradeRequestQuote: PropTypes.func,
    removeRequestQuote: PropTypes.func,
    removeRequestQuoteBundle: PropTypes.func,
    saveAttachServices: PropTypes.func,
    metaRequest: PropTypes.any,
    request: PropTypes.shape({
        id: PropTypes.number,
        requestQuotes: PropTypes.array,
        requestHotels: PropTypes.array,
        user: PropTypes.shape({
            userEmails: PropTypes.array,
            conciergeGroups: PropTypes.array,
        }),
    }),
};

const mapStateToProps = () =>
{
    const requestSelector = buildRequestSelector();
    const metaRequestSelector = buildMetaRequestSelector();

    return (state, props) => ({
        request: requestSelector(state, props.requestId),
        metaRequest: metaRequestSelector(state, props.requestId),
    });
};

const mapDispatchToProps = (dispatch) => ({
    saveAttachServices(requestQuoteId, requestHotelId, vendorServiceIds)
    {
        return dispatch(attachServices(requestQuoteId, requestHotelId, vendorServiceIds));
    },
    removeRequestQuote(requestQuoteId)
    {
        return dispatch(deleteRequestQuote(requestQuoteId));
    },
    upgradeRequestQuote(requestQuoteId, data)
    {
        return dispatch(updateRequestQuote(requestQuoteId, data));
    },
    getRequest(requestId)
    {
        return dispatch(loadRequest(requestId, requestDetailsIncludes));
    },
    removeRequestQuoteBundle(requestQuoteId, requestQuoteBundleId)
    {
        return dispatch(deleteRequestQuoteBundle(requestQuoteId, requestQuoteBundleId));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestSummary);
